module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kCC0M"))).then(() => parcelRequire('d0iPb'));